import React, { useMemo } from 'react';

import { type MRT_ColumnDef } from 'material-react-table';
import { Link } from 'react-router-dom';

import { formatMoney, getServiceType } from 'utils';

import { TableGridLocal } from '../../../components/TableGridLocal';
import { PAGE_STRATEGIES, PAGE_STRATEGY_POSITIONS } from '../../../screens/Routes';
import { Strategy } from '../../../types/strategy';

type Props = {
  strategies: Strategy[];
};

export const StrategiesTable: React.FC<Props> = ({ strategies }) => {
  const columns = useMemo<MRT_ColumnDef<Strategy>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Название',
        filterVariant: 'text',
        Cell: ({ cell }) => (
          <Link to={`${PAGE_STRATEGIES}/${cell.row.original.id}/${PAGE_STRATEGY_POSITIONS}`}>
            {cell.getValue() as string}
          </Link>
        ),
      },
      {
        accessorFn: (row) => getServiceType(row),
        id: 'serviceType',
        header: 'Тип услуги',
        filterVariant: 'multi-select',
        filterSelectOptions: ['Автоследование', 'Автоконсультирование', 'Инвесткопилка'],
      },
      {
        accessorKey: 'strategyAccounts',
        header: 'Количество клиентов',
        enableColumnFilter: false,
      },
      {
        accessorKey: 'strategyAccountPositions',
        header: 'Сумма активов',
        enableColumnFilter: false,
        Cell: ({ cell }) => formatMoney(cell.row.original.strategyAccountPositions, 'RUB'),
      },
      {
        accessorKey: 'fintargetUrl',
        header: 'Страница стратегии',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }) => (
          <>
            {cell.row.original.fintargetUrl && (
              <a href={cell.row.original.fintargetUrl} target="_blank" rel="noreferrer">
                Fintarget
              </a>
            )}
            {cell.row.original.oneLink && ' | '}
            {cell.row.original.oneLink && (
              <a href={cell.row.original.oneLink} target="_blank" rel="noreferrer">
                One Link
              </a>
            )}
            {cell.row.original.bcsUrl && ' | '}
            {cell.row.original.bcsUrl && (
              <a href={cell.row.original.bcsUrl} target="_blank" rel="noreferrer">
                bcs.ru
              </a>
            )}
          </>
        ),
      },
    ],
    [],
  );

  return (
    <TableGridLocal name="dashboard-strategies" columns={columns} data={strategies} totalRowCount={strategies.length} />
  );
};
